import { render } from "./pb-alumni.vue?vue&type=template&id=0b6684f2"
import script from "./pb-alumni.vue?vue&type=script&lang=js"
export * from "./pb-alumni.vue?vue&type=script&lang=js"

import "./pb-alumni.vue?vue&type=style&index=0&id=0b6684f2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__